<template>
  <div class="fantasy-contest-screen">
    <loading-state :state="state"></loading-state>
    <div v-if="contest">
      <h2>{{contest.name}}</h2>
      <div class="detail wrap-on-mobile reversed">
        <div class="info-col hide-on-app-hang-left">
          <contest-detail
            :contest="contest"
            :canEdit="canEdit"></contest-detail>
          <div v-if="contestTemplate">
            <h5 class="top-space bottom-space">Template</h5>
            <div class="boxes">
              <div class="boxed contest-info">
                <div class="boxes compact width30">
                  <div>
                    <div>{{contestTemplate.name}}</div>
                    <label>Name</label>
                  </div>
                  <div>
                    <div>{{contestTemplate.kind.value | capitalise}}</div>
                    <label>Kind</label>
                  </div>
                </div>
                <div class="boxes compact width30">
                  <div>
                    <div><small>{{contestTemplate.created | simpleDateTimeString}}</small></div>
                    <label>Created</label>
                  </div>
                  <div>
                    <div><small>{{contestTemplate.updated | simpleDateTimeString}}</small></div>
                    <label>Updated</label>
                  </div>
                  <div v-if="contestTemplate.created_by">
                    <div><small>{{contestTemplate.created_by.name}}</small></div>
                    <label>Created by</label>
                  </div>
                </div>
              </div>
            </div>
            <contest-detail
              :contest="contestTemplate.contest"
              :canEdit="false"></contest-detail>
          </div>
        </div>
        <div class="leaderboard-col maxwidth-on-app-hang-left">
          <div class="info">
            {{membersCount}} members participated
          </div>
          <contest-leaderboard :contest="contest"></contest-leaderboard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ContestDetail  from '@/components/cricket/fantasy/ContestDetail'
import ContestLeaderboard  from '@/components/cricket/fantasy/ContestLeaderboard'

import { FantasyContest } from '@/models/fantasy'
import { DataState, AppState } from '@/state'

export default {
  components: {
    'ContestDetail': ContestDetail,
    'ContestLeaderboard': ContestLeaderboard,
  },
  data () {
    return {
      contestKey: this.$route.params.key,
      contest: null,
      contestTemplate: null,
      membersCount: null,
      canEdit: null,
      state: DataState.newLoading(),
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.params.key !== from.params.key) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },
  mounted () {
    this.onViewOpenned()
  },
  methods: {
    onViewOpenned () {
      this.contestKey = this.$route.params.key
      const newTitle = 'loading...'
      AppState.updateActivePage(`cricket_team_${this.teamKey}`)
      AppState.updateTitles(newTitle, newTitle)

      FantasyContest.fetch(this.contestKey).then(res => {
        this.contest = res.contest
        this.contestTemplate = res.template
        this.membersCount = res.membersCount
        this.canEdit = res.canEdit
        const newTitle = `${this.contest.name}`
        AppState.updateTitles(newTitle, newTitle)

        this.state.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },
    prepareToReopen () {
      this.contestKey = null
      this.contest = null
      this.contestTemplate = null
      this.membersCount = null
      this.canEdit = null
    },
    refreshView () {

    },
  }
}
</script>
